import React from 'react';
import { Col, Row, Grid } from 'react-styled-flexboxgrid';
import Styled from './Header.style';
import { getVariable, isLoggedIn } from '../../../helpers';
import * as _ from 'lodash';
import { AppConfig } from '../../../interfaces';
import WithHeader from '../../WithHeader';
import { Helmet } from 'react-helmet';
import LanguageSelect from '../../LanguageSelect';
import Navigation from '../../Navigation';
import { useTranslation } from 'react-i18next';
// import Notifications from '../../Notifications';
import ActionBanner from '../../ActionBanner';
import Logo from '../../Logo';
declare global {
  interface Window {
    onBambuserOneToOneReady: any;
  }
}

interface HeaderProps {
  appConfig: AppConfig;
  appWidth: number;
  logOut: Function;
  getPreferences: Function;
  homepage: any;
  user: any;
  location: any;
  clientSlug: any;
  locationConfig: Function;
  app: any;
  swsmLocation: any;
  bambuserStatus: any;
  getAvailableRewards: Function;
  availableRewards: any;
}

const Header: React.FC<HeaderProps> = props => {
  const swsmInternal = getVariable('mode', 'swsm', false);
  const {
    appConfig,
    user,
    appWidth,
    getAvailableRewards,
    homepage,
    location,
    app,
    locationConfig,
    getPreferences,
    bambuserStatus,
  } = props;

  const { data } = appConfig;
  const isDesktop = appWidth > 800;

  const logged = Boolean(isLoggedIn());

  const [t] = useTranslation('common');
  React.useEffect(() => {
    if (logged) {
      getAvailableRewards();
    }
    if (logged && !bambuserStatus.done) {
      getPreferences();
    }
  }, [getPreferences, logged, bambuserStatus.done, getAvailableRewards]);

  const postcode = _.get(app, 'userData.data.postcode');
  const bambuser = _.get(app, 'clientConfig.data.data.bambuser_enabled');

  React.useEffect(() => {
    if (logged && postcode && !bambuserStatus.done) {
      locationConfig(postcode);
    }
  }, [locationConfig, logged, postcode, bambuserStatus.done]);
  const clientConfig = _.get(props, 'app.clientConfig.data');
  const locationConfigs = _.get(props, 'app.locationConfig.data');
  const availableLangsLength = _.get(clientConfig, 'data.availableLanguages.length');

  window.onBambuserOneToOneReady = function(BambuserOneToOneEmbed) {
    // This method will be invoked when embed.js has loaded and Bambuser
    // One-to-One API is available.
    // Creating an instance directly will allow to detect connect links
    // that will automatically open the Live Meeting overlay on page load.
    const oneToOneEmbed = new BambuserOneToOneEmbed({
      orgId: 'oqWtVXfvXewV5MjGw2Uv',
      triggers: [
        'connect-link', // activate the connect link - Unrelated to OLW, yet mandatory
      ],
    });

    // Connect CTA button to open Bambuser One-to-One overlay.
    const button = document.querySelector('#start-one-to-one');
    button &&
      button.addEventListener('click', () => {
        oneToOneEmbed.show();
      });
  };

  if (!data || _.isEmpty(data)) {
    return null;
  }

  const bambuserChat = () => {
    if (bambuser) {
      return (
        <div
          style={
            !swsmInternal || homepage || location.pathname === '/login' || location.pathname === '/questions'
              ? { visibility: 'hidden' }
              : { visibility: 'visible' }
          }
        >
          <>
            <Helmet>
              <script id="bambuser-one-to-one" async src="https://one-to-one.bambuser.com/embed.js"></script>
            </Helmet>
            <Styled.BambuserWrap role="videoChat">
              <Styled.TextWrap>
                {t('gamification.video_chat.title')}
                <Styled.ButtonBambuser onClick={() => document.getElementById('start-one-to-one')?.click()}>
                  {t('gamification.video_chat.description')}
                </Styled.ButtonBambuser>
              </Styled.TextWrap>

              <Styled.ChatButton>
                <button id="start-one-to-one"></button>
              </Styled.ChatButton>
            </Styled.BambuserWrap>
          </>
        </div>
      );
    }
  };

  return (
    <>
      <Styled.Wrap
        style={{ backgroundColor: homepage && '#D7F1FF' }}
        isDesktop={isDesktop}
        homepage={homepage}
        id="header"
      >
        {bambuserChat()}

        <Styled.FixedPos
          style={
            homepage || !swsmInternal
              ? { position: 'relative', backgroundColor: 'transparent' }
              : { position: 'fixed', backgroundColor: 'white' }
          }
        >
          <Grid style={!swsmInternal ? { width: '100%' } : null}>
            <Row>
              <Col xs={12}>
                <Styled.TopMenu
                  className="test-nav"
                  data-test="TopMenu"
                  style={{ justifyContent: !swsmInternal ? 'flex-end' : null }}
                >
                  {!swsmInternal ? null : (
                    <Logo availableRewards={props.availableRewards} swsmLocation={props.swsmLocation} user={user} />
                  )}

                  {swsmInternal &&
                  !logged &&
                  (!homepage ||
                    location.pathname !== '/login' ||
                    location.pathname !== '/india' ||
                    !locationConfigs) ? (
                      <Col style={{ margin: 'auto', marginRight: '0', justifyContent: 'flex-end', paddingTop: '4px' }}>
                        <LanguageSelect location={props.location} />
                      </Col>
                    ) : null}

                  <Navigation location={props.location} />
                </Styled.TopMenu>
              </Col>
            </Row>
          </Grid>
        </Styled.FixedPos>

        {!logged ? null : (
          <>
            <div style={{ backgroundColor: logged ? '#e9eef5' : '', marginTop: swsmInternal ? '83px' : '0px' }}>
              <Grid style={!swsmInternal ? { width: '100%' } : null}>
                <Row>
                  <Col xs={12}>
                    <WithHeader swsmLocation={props.location}>
                      {swsmInternal && clientConfig && availableLangsLength === 1 ? null : (
                        <div
                          style={{
                            height: '72px',
                            display: 'flex',
                            alignItems: 'center',
                            marginLeft: '16px',
                            justifyContent: 'flex-end',
                          }}
                        >
                          <LanguageSelect location={props.location} />
                        </div>
                      )}
                    </WithHeader>
                  </Col>
                </Row>
              </Grid>
            </div>
          </>
        )}
        <ActionBanner />
      </Styled.Wrap>
    </>
  );
};

export default Header;
